import { render, staticRenderFns } from "./VueSkipToList.vue?vue&type=template&id=88aab334&"
import script from "./VueSkipToList.vue?vue&type=script&lang=ts&"
export * from "./VueSkipToList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports